export { default } from './Thumbnail.js';
